/**
 * Retrieve Brandfetch Tool Schema
 *
 * Download and process specific logo or brand colors from Brandfetch.
 */
import { z } from "zod";
// ═══════════════════════════════════════════════════════════════════════════
// PARAMS SCHEMA
// ═══════════════════════════════════════════════════════════════════════════
/**
 * Logo theme options (light/dark background)
 * @see https://docs.brandfetch.com/logo-api/parameters
 */
export const LogoThemeEnum = z.enum(["light", "dark"]);
export const LogoTypeEnum = z.enum(["icon", "logo", "symbol"]);
/**
 * Logo variant: combination of theme and type
 * Examples: "light_icon", "dark_logo", "icon" (no theme), "logo" (no theme)
 */
export const LogoVariantEnum = z.enum([
    // With theme
    "light_icon",
    "light_logo",
    "light_symbol",
    "dark_icon",
    "dark_logo",
    "dark_symbol",
    // Without theme (default)
    "icon",
    "logo",
    "symbol"
]);
/**
 * Retrieve Brandfetch parameters
 */
export const RetrieveBrandfetchParamsSchema = z.object({
    uiDescription: z.string()
        .describe("Brief description (max ~15 words) of what this tool call is attempting."),
    companyDomain: z.string()
        .min(1, "Company domain is required")
        .describe("Domain from searchBrandfetch result (e.g., 'microsoft.com')"),
    assetType: z.enum(["logo", "brand_colors"])
        .describe("Type of asset to retrieve. When 'logo', ALL available variants are automatically retrieved."),
    requirementId: z.string()
        .min(1, "Requirement ID is required")
        .describe("The requirement ID this asset fulfills"),
    logoVariant: LogoVariantEnum
        .optional()
        .describe("(Internal use only - ignored by tool. All variants are fetched automatically)"),
    logoOnly: z.boolean()
        .optional()
        .default(true)
        .describe("If true, use Logo API for fast retrieval. If false, use Brand API for full details."),
});
